module.exports = __webpack_public_path__ + "static/media/BamideleDavid.44396153.jpg";